import React from "react"
import { SortableTh } from "../../components/SortableColumns"
import { DetailLink } from "../../components/Table/DetailLink"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { useNavigate } from "react-router-dom"
import { Col, Row } from "react-bootstrap"
import { ConnectedIcon } from "../../components/ConnectedIcon"
import { SystemStatusIcon } from "../../components/SystemStatusIcon"
export const DeviceOverview = () => {
    const endpoint = "/v2/management/devices"

    const jsonDataField = (setData, data) => setData(data.devices)
    const navigate = useNavigate()

    const filter = {
        initial: "",
        onSearch: (_, searchText) => searchText,
    }

    const error = {
        title: "Failed to get devices",
        body:
            "Something went wrong while getting the devices, " +
            "see the console for more details.",
    }

    const emptyMsg = "No devices found"

    const table = {
        header: [
            <SortableTh column="serial_number">SN</SortableTh>,
            <SortableTh column="device_type">Type</SortableTh>,
            <th>Firmware</th>,
            <th>Connected</th>,
            <SortableTh column="highest_active_error">Status</SortableTh>,
            <th>Actions</th>,
        ],
        body: (value) => (
            <tr
                key={value.device_id}
                onClick={() => {
                    navigate(`/device/${value.device_id}`)
                }}
            >
                <td>{value.sn}</td>
                <td>{value.type}</td>
                <td>{value.current_version}</td>
                <td>
                    <ConnectedIcon connected={value.connected} />
                </td>
                <td>
                    <SystemStatusIcon status={value.highest_error_level} />
                </td>
                <td>
                    <DetailLink to={`/device/${value.device_id}`} />
                </td>
            </tr>
        ),
    }

    return (
        <Row className="content-section">
            <Col>
                <h2 className="mb-3">Devices</h2>
                <GenericOverview
                    apiEndpoint={endpoint}
                    dataField={jsonDataField}
                    filter={filter}
                    error={error}
                    table={table}
                    emptyMsg={emptyMsg}
                />
            </Col>
        </Row>
    )
}
